import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import './App.css';

import Login from './Pages/Login/Login';
import Account from './Pages/Login/Account';


import AdminDashboard from './Pages/Dashboard/AdminDashboard';
import AdminStatistics from './Pages/Statistics/AdminStatistics';
import AdminUsers from './Pages/Users/AdminUsers';
import AdminDocuments from './Pages/Documents/AdminDocuments';
import CreateDocuments from './Pages/Documents/CreateDocuments';
import ViewDocument from './Pages/Documents/ViewDocument'

import DetailsDashboard from './Pages/Dashboard/DetailsDashboard';
import CreateUser from './Pages/Users/CreateUser';
import EditUser from './Pages/Users/EditUsers';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay datos de autenticación en localStorage al cargar la aplicación
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setIsAuthenticated(true);
      setUser(storedUser);
    }
    setLoading(false); // Termina el estado de carga
  }, []);
  useEffect(() => {
    const toastMessage = localStorage.getItem('toastMessage');
    if ( toastMessage) {
      toast.success(toastMessage, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'dark',
      });

      localStorage.removeItem('toastMessage');
    }
  }, []);

  const login = (user) => {
    setIsAuthenticated(true);
    setUser(user);
    localStorage.setItem('user', JSON.stringify(user));
  };

 
  const PrivateRoute = ({ element: Element, allowedRoles, ...rest }) => {
    const userRole = user ? (user.isAdmin === 2 ? "Administrador" : "Usuario") : "Desconocido";
    if (loading) {
      return <div>Cargando...</div>; 
    }
    if (!isAuthenticated) {
      return <Navigate to="/" />;
    }
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" />;
    }

    

    // Renderiza el componente recibido como elemento
    return <Element {...rest} />;
  };

  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<Login login={login} />} />
        


        {/* Rutas protegidas */}
        <Route path="/Account" element={<PrivateRoute element={Account} allowedRoles={['Administrador', 'Usuario']} />} />
        <Route
          path="/AdminDashboard"
          element={<PrivateRoute element={AdminDashboard} allowedRoles={['Administrador', 'Usuario']} />}
        />
        <Route
          path="/DetailsDashboard"
          element={
            <PrivateRoute
              element={(props) => <DetailsDashboard {...props} />} allowedRoles={['Administrador', 'Usuario']}
            />
          }
        />
        <Route path="/AdminStatistics" element={<PrivateRoute element={AdminStatistics} allowedRoles={['Administrador', 'Usuario']} />} 
        />
        <Route path="/AdminUsers" element={<PrivateRoute element={AdminUsers} allowedRoles={['Administrador', 'Usuario']}  />} />
        <Route path="/CreateUser" element={<PrivateRoute element={CreateUser} allowedRoles={['Administrador', 'Usuario']}  />} />
        <Route
          path="/EditUser/:userId"
          element={<PrivateRoute element={EditUser} allowedRoles={['Administrador', 'Usuario']}/>}
        />
        <Route path="/AdminDocuments" element={<PrivateRoute element={AdminDocuments}  allowedRoles={['Administrador']}/>} />
        <Route path="/CreateDocuments" element={<PrivateRoute element={CreateDocuments}  allowedRoles={['Administrador']} />} />
        <Route path="/ViewDocument/:idFile" element={<PrivateRoute element={ViewDocument} allowedRoles={['Administrador']} />} />
        
        
        {/* <Route path="/SuperDashboard" element={<SuperDashboard />} />
        <Route path="/SuperStatistics" element={<SuperStatistics />} />
        <Route path="/SuperUsers" element={<SuperUsers />} />
        <Route path="/SuperDocuments" element={<SuperDocuments />} /> */}
        
        

         {/* <Route path="/ManagerDashboard" element={<ManagerDashboard  />} />
        <Route path="/ManagerStatistics" element={<ManagerStatistics  />} />
        <Route path="/ManagerDocuments" element={<ManagerDocuments  />} /> */}

        
      </Routes>
      <ToastContainer/>
    </Router>
  );
}

export default App;

